module.exports = __webpack_public_path__ + "img/TradingView-icon3.c6be0d22.svg";